export default __webpack_public_path__ + "static/media/bg-pagamento.362a3457.webp";